module.exports = __webpack_public_path__ + "img/天平台.86fd9b4d.jpg";